<template>
  <div id="modalMLog" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("other.操作日志") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <table class="table mg-b-0">
            <thead>
              <tr>
                <th class="tx-10-force tx-mont tx-medium hidden-xs-down">
                  {{ $t("distributor.操作描述") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in order_log" :key="index">
                <td class="valign-middle hidden-xs-down">
                  <div>{{ item }}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-show="(order_log || []).length == 0"
            class="nodata mg-t-50 mg-b-50 text-center tx-24"
          >
            {{ $t("transfer.当前没有操作日志") }}
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("transfer.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["order_log"],
};
</script>